(()=>{'use strict';













const products=JSON.parse(document.getElementById('dm-products')?.textContent||'{}'), settings=JSON.parse(document.getElementById('dm-settings')?.textContent||'{}');













const q=(s,r=document)=>r.querySelector(s),qa=(s,r=document)=>[...r.querySelectorAll(s)];













const money=c=>new Intl.NumberFormat('it-IT',{style:'currency',currency:settings.currency||'USD',currencyDisplay:'narrowSymbol'}).format(c/100), esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));













const opened=[];function open(id){const d=document.getElementById(id);if(!d||d.open)return;d.showModal();d.scrollTop=0;opened.push(d);document.body.style.overflow='hidden';}function close(d){d.close();const i=opened.indexOf(d);if(i>=0)opened.splice(i,1);if(!opened.length)document.body.style.overflow='';if(d.id==='dm-cart'&&q('[data-dm-cart-page]'))location.href='/products/k';if(d.id==='dm-promo')sessionStorage.setItem('dm-promo-dismissed','1');}













qa('dialog').forEach(d=>{d.addEventListener('cancel',e=>{e.preventDefault();close(d)});d.addEventListener('click',e=>{if(e.target===d){const b=d.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)close(d)}})});













async function api(path,data){const r=await fetch(window.Shopify?.routes?.root?window.Shopify.routes.root+path:'/'+path,{method:data?'POST':'GET',headers:data?{'Content-Type':'application/json'}:{},body:data?JSON.stringify(data):undefined});const j=await r.json();if(!r.ok)throw new Error(j.description||j.message||'Operazione non riuscita. Riprova.');return j;}













function error(e,root){const target=q('.dm-error',root||document);if(target)target.textContent=e.message;}













function cartOptions(i){const p=products[i.handle];if(!['k','reggiseno-minimizzatore-invisibile','reggiseno-correttore-di-postura-sostegno-lift-silhouette'].includes(i.handle)||!p)return i.variant_title==='Default Title'?'':esc(i.variant_title);const variant=p.variants.find(v=>v.id===i.variant_id);return `<span class="dm-cart-option-title">${p.options.map(o=>esc(typeof o==='string'?o:o.name)).join(', ')}:</span><span class="dm-cart-variants" data-cart-variant-line="${esc(i.key)}" data-current-variant="${i.variant_id}" data-cart-quantity="${i.quantity}" data-cart-handle="${esc(i.handle)}">${p.options.map((o,n)=>`<label><span class="visually-hidden">${esc(typeof o==='string'?o:o.name)}</span><select aria-label="${esc(typeof o==='string'?o:o.name)}">${[...new Set(p.variants.map(v=>v.options[n]))].map(value=>`<option ${variant?.options[n]===value?'selected':''}>${esc(value)}</option>`).join('')}</select></label>`).join('')}</span>`;}













const trash='<svg width="17" height="19" viewBox="0 0 20 22" fill="none" aria-hidden="true"><path d="M3 5h14M7 5V2h6v3M5 5l1 15h8l1-15M8 9v7m4-7v7" stroke="currentColor" stroke-width="1.7"/></svg>';













function cartItem(i){return `<article class="dm-cart-item"><a href="${esc(i.url)}"><img src="${esc(i.image)}" alt="${esc(i.product_title)}"></a><div class="dm-cart-item-info"><h3><a href="${esc(i.url)}">${esc(i.product_title)}</a></h3><div>${cartOptions(i)}</div><div class="dm-qty"><button data-change="${esc(i.key)}" data-quantity="${i.quantity-1}" aria-label="Riduci quantità">−</button><span aria-label="Quantità">${i.quantity}</span><button data-change="${esc(i.key)}" data-quantity="${i.quantity+1}" aria-label="Aumenta quantità">+</button></div></div><div class="dm-cart-item-prices">${i.original_line_price>i.final_line_price?`<s>${money(i.original_line_price)}</s>`:''}<strong>${money(i.final_line_price)}</strong>${i.original_line_price>i.final_line_price?`<span class="dm-cart-saving">◆<br>Risparmi<br>${money(i.original_line_price-i.final_line_price)}</span>`:''}<button class="dm-remove" data-change="${esc(i.key)}" data-quantity="0" aria-label="Rimuovi ${esc(i.product_title)}">${trash}</button></div></article>`;}













function upsell(c){const bra=products['reggiseno-minimizzatore-invisibile'],ebook=products['la-verita-sul-ventre-postpartum'];let html='';if(ebook&&!c.items.some(i=>i.handle===ebook.handle)){const v=ebook.variants.find(v=>v.available);if(v)html+=`<form class="dm-cart-offer" data-ebook-upsell><a href="/products/${esc(ebook.handle)}"><img src="${esc(ebook.featured_image)}" alt="${esc(ebook.title)}"></a><div><h3>${esc(ebook.title)}</h3><div class="dm-cart-offer-price"><strong>${money(Math.round(v.price*.8))}</strong> <s>${money(v.compare_at_price||v.price)}</s> <span>Risparmi 60%</span></div><button type="submit">AGGIUNGI AL CARRELLO</button></div></form>`;}if(bra&&!c.items.some(i=>i.handle===bra.handle)){const v=bra.variants.find(v=>v.available);if(v){const opts=bra.options.map((o,n)=>`<label><span class="visually-hidden">${esc(typeof o==='string'?o:o.name)}</span><select aria-label="${esc(typeof o==='string'?o:o.name)}">${[...new Set(bra.variants.map(v=>v.options[n]))].map(x=>`<option ${v.options[n]===x?'selected':''}>${esc(x)}</option>`).join('')}</select></label>`).join('');html+=`<form class="dm-cart-offer" data-cart-upsell><a href="/products/${esc(bra.handle)}"><img src="${esc(v.featured_image?.src||bra.featured_image)}" alt="${esc(bra.title)}"></a><div><h3><a href="/products/${esc(bra.handle)}">${esc(bra.title)}</a></h3><div class="dm-cart-offer-price"><strong>${money(Math.round(v.price*.8))}</strong> <s>${money(v.compare_at_price||v.price)}</s> <span>Risparmi ${Math.round((1-v.price*.8/(v.compare_at_price||v.price))*100)}%</span></div><span class="dm-cart-option-title">Colore, Coppa, Taglia:</span><div class="dm-cart-variants">${opts}</div><button type="submit">AGGIUNGI AL CARRELLO</button></div></form>`;}}return html?`<div class="dm-cart-offers">${html}</div>`:'';}













let cartTimerEnd=Number(sessionStorage.getItem('dm-cart-timer'))||0;













function tickCart(){const node=q('[data-cart-timer]');if(!node||!cartTimerEnd)return;const now=Date.now();if(cartTimerEnd<=now){cartTimerEnd=now+8*60*1000;sessionStorage.setItem('dm-cart-timer',String(cartTimerEnd));}const remaining=Math.max(0,Math.ceil((cartTimerEnd-now)/1000));node.textContent=String(Math.floor(remaining/60)).padStart(2,'0')+':'+String(remaining%60).padStart(2,'0');}













setInterval(tickCart,1000);













async function cart(){let c=await api('cart.js');const staleGifts=c.items.filter(i=>i.properties?._DonneaGift==='1');for(const line of staleGifts){await api('cart/change.js',{id:line.key,quantity:0});}if(staleGifts.length)c=await api('cart.js');
const owned=['DONNEA-EBOOK-OMAGGIO','DONNEA-POPUP-1PIU1','DONNEA-2PIU2','DONNEA-3PIU3','DONNEA-QUANTITA-2','DONNEA-QUANTITA-4','DONNEA-QUANTITA-6'];const currentCodes=(c.discount_codes||[]).filter(d=>!owned.includes(d.code.toUpperCase())&&(d.code.toUpperCase()!=='DONNEA-CARRELLO-REGGISENO'||c.items.some(i=>i.handle==='reggiseno-minimizzatore-invisibile'))&&(d.code.toUpperCase()!=='DONNEA-CARRELLO-EBOOK'||c.items.some(i=>i.handle==='la-verita-sul-ventre-postpartum'))).map(d=>d.code);const slipQty=c.items.filter(i=>i.handle==='k').reduce((a,i)=>a+i.quantity,0);if(slipQty>=2){const tier=slipQty>=6?6:slipQty>=4?4:2;const offer=tier===2?settings.offers.popup:tier===4?settings.offers.pdp:settings.offers.value;currentCodes.push(slipQty===tier?offer.code:'DONNEA-QUANTITA-'+tier);}const desired=currentCodes.join(',');if(desired.toUpperCase()!==(c.discount_codes||[]).map(d=>d.code).join(',').toUpperCase()){await api('cart/update.js',{discount:desired});c=await api('cart.js');}qa('[data-cart-count]').forEach(e=>{e.textContent=c.item_count||''});const b=q('[data-cart-body]');













if(!c.items.length){b.innerHTML='<div class="dm-empty-cart"><svg width="32" height="32" viewBox="0 0 24 26" fill="none" aria-hidden="true"><path d="M5 8h14l1 16H4L5 8Z M9 9V6a3 3 0 0 1 6 0v3" stroke="currentColor" stroke-width="1.4"/></svg><p>Your cart is empty</p></div>';cartTimerEnd=0;sessionStorage.removeItem('dm-cart-timer');return c;}













if(!cartTimerEnd){cartTimerEnd=Date.now()+8*60*1000;sessionStorage.setItem('dm-cart-timer',String(cartTimerEnd));}













b.innerHTML=`<div class="dm-cart-timer">Il carrello scadrà tra <strong data-cart-timer></strong></div><div class="dm-cart-scroll"><div class="dm-cart-items">${c.items.filter(i=>i.properties?._DonneaGift!=='1').map(cartItem).join('')}</div>${upsell(c)}<p class="dm-cart-guarantee">♧ <span>Vestibilità garantita: se non è della taglia giusta, la cambiamo gratuitamente con quella corretta.</span></p></div><div class="dm-cart-summary"><p><strong>saldi autunnali</strong><strong>${money(c.total_price)}</strong></p><form action="/cart" method="post"><button class="dm-button" name="checkout" type="submit">Acquista ora</button></form><div class="dm-cart-payments">${q('#dm-native-payments')?.innerHTML||''}</div><small>Provalo senza rischi: hai 30 giorni per innamorartene o ricevere un rimborso completo.</small></div>`;tickCart();return c;}













async function add(id,quantity=1){await api('cart/add.js',{items:[{id:Number(id),quantity}]});await cart();open('dm-cart');}













function quick(handle){if(q('#dm-promo')?.open)close(q('#dm-promo'));const p=products[handle];if(!p?.variants?.length)return;const v=p.variants.find(v=>v.available)||p.variants[0];const img=typeof p.featured_image==='string'?p.featured_image:p.featured_image?.src;













const offer=handle==='k'?settings.offers?.pdp:null;













const count=1;













const options=Array.from({length:count},(_,unit)=>`<fieldset class="dm-unit"><legend>${count>1?'Slip '+(unit+1):'Scegli la tua variante'}</legend>${p.options.map((o,index)=>`<label>${esc(typeof o==='string'?o:o.name)}<select data-unit="${unit}" name="option${unit}-${index}">${[...new Set(p.variants.map(v=>v.options[index]))].map(val=>`<option ${v.options[index]===val?'selected':''}>${esc(val)}</option>`).join('')}</select></label>`).join('')}</fieldset>`).join('');













const content=document.getElementById('dm-quick-content-'+handle)?.innerHTML||`<h1>${esc(p.title)}</h1>`;













q('[data-quick-body]').innerHTML=`<div class="dm-quick-grid"><div><img class="dm-quick-image" src="${esc(img)}" alt="${esc(p.title)}"></div><div>${content}${offer?`<div class="dnn-offerbox"><div class="dnn-offerbox__pill">🎁 2+2 in omaggio — ${money(Math.round(Number(offer.total)*100))} (${money(Math.round(Number(offer.total)*25))} a slip)</div></div>`:`<p class="dm-price" data-quick-price><strong>${money(v.price)}</strong> ${v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s> <span class="dm-quick-sale">Offerta di Primavera</span>`:''}</p>`}<button type="button" class="dm-size-link" data-guide="${esc(handle)}">📏 Guida alle taglie ›</button><form data-quick-form data-handle="${esc(handle)}" data-offer=""><div class="dm-quick-options" hidden>${options}</div>${handle==='k'?(q('#dm-quick-official')?.innerHTML||''):''}<button class="dm-button" type="submit"><span>AGGIUNGI AL CARRELLO</span></button></form><div class="dm-native-payments">${q('#dm-native-payments')?.innerHTML||''}</div>${q('#dm-quick-reassurance')?.innerHTML||''}<a class="dm-full-details" href="/products/${esc(handle)}">Visualizza dettagli completi →</a></div></div>`;













q('#dm-quick .dm-error').textContent='';q('#dm-quick').setAttribute('aria-label','Scegli opzioni — '+p.title);open('dm-quick');q('.dm-quick-scroll').scrollTop=0;}













function selectedVariants(f){const p=products[f.dataset.handle];return qa('.dm-unit',f).map(unit=>{const values=qa('select',unit).map(x=>x.value);return p.variants.find(v=>v.options.every((x,i)=>x===values[i]));});}













document.addEventListener('click',async e=>{const closeBtn=e.target.closest('[data-close]');if(closeBtn){close(closeBtn.closest('dialog'));return;}const b=e.target.closest('button,[data-open]');if(!b)return;













try{if(b.closest('#dm-cart'))q('#dm-cart .dm-error').textContent='';if(b.dataset.open){if(b.dataset.open==='dm-cart')await cart();open(b.dataset.open);}if(b.dataset.quick)quick(b.dataset.quick);if(b.dataset.guide){const guides=JSON.parse(q('#dm-guides').textContent);q('[data-guide-image]').src=guides[b.dataset.guide];open('dm-guide');}if(b.dataset.addId){b.disabled=true;await add(b.dataset.addId);b.disabled=false;}if(b.dataset.change){b.disabled=true;await api('cart/change.js',{id:b.dataset.change,quantity:Number(b.dataset.quantity)});await cart();}













if(b.hasAttribute('data-slide')||b.hasAttribute('data-slide-index')){const el=q('.dm-cards'),width=el.firstElementChild.getBoundingClientRect().width+24;const target=b.hasAttribute('data-slide-index')?Number(b.dataset.slideIndex):Math.round(el.scrollLeft/width)+Number(b.dataset.slide);el.scrollTo({left:Math.max(0,Math.min(2,target))*width,behavior:'smooth'});}













}catch(err){b.disabled=false;error(err,b.closest('dialog'));}});













document.addEventListener('change',e=>{const f=e.target.closest('[data-cart-upsell]');if(!f)return;const p=products['reggiseno-minimizzatore-invisibile'],values=qa('select',f).map(s=>s.value),v=p.variants.find(v=>v.options.every((x,n)=>x===values[n]));q('button[type=submit]',f).disabled=!v?.available;const src=v?.featured_image?.src||p.featured_image;if(src){const img=q('img',f);img.src=src;img.alt=p.title+' — '+values.join(', ');}});









document.addEventListener('change',async e=>{const line=e.target.closest('[data-cart-variant-line]');if(!line)return;const selects=qa('select',line),values=selects.map(s=>s.value),p=products[line.dataset.cartHandle],v=p.variants.find(v=>v.options.every((x,n)=>x===values[n]));if(!v?.available){error(new Error('Variante non disponibile.'),q('#dm-cart'));await cart();return;}if(v.id===Number(line.dataset.currentVariant))return;selects.forEach(s=>s.disabled=true);q('#dm-cart .dm-error').textContent='';let old,priorNew,added=false;try{const before=await api('cart.js');old=before.items.find(i=>i.key===line.dataset.cartVariantLine)||before.items.find(i=>i.variant_id===Number(line.dataset.currentVariant));if(!old)throw new Error('Il carrello è cambiato. Riprova.');priorNew=before.items.find(i=>i.variant_id===v.id&&JSON.stringify(i.properties||{})===JSON.stringify(old.properties||{}));await api('cart/add.js',{items:[{id:v.id,quantity:old.quantity,properties:old.properties||{}}]});added=true;const fresh=await api('cart.js'),previous=fresh.items.find(i=>i.variant_id===old.variant_id&&JSON.stringify(i.properties||{})===JSON.stringify(old.properties||{}));if(!previous)throw new Error('Impossibile aggiornare la variante.');await api('cart/change.js',{id:previous.key,quantity:0});added=false;await cart();}catch(err){if(added){try{const fresh=await api('cart.js'),created=fresh.items.find(i=>i.variant_id===v.id&&JSON.stringify(i.properties||{})===JSON.stringify(old.properties||{}));if(created)await api('cart/change.js',{id:created.key,quantity:priorNew?.quantity||0});}catch{err=new Error('Controlla le quantità nel carrello prima di continuare.');}}await cart();error(err,q('#dm-cart'));}});













q('.dm-cards')?.addEventListener('scroll',e=>{const el=e.target,w=el.firstElementChild.getBoundingClientRect().width+24,idx=Math.round(el.scrollLeft/w);qa('[data-slide-index]').forEach((b,i)=>b.setAttribute('aria-current',String(i===idx)));q('[data-slide="-1"]').disabled=idx===0;q('[data-slide="1"]').disabled=idx===2;});













document.addEventListener('change',e=>{const f=e.target.closest('[data-quick-form]');if(!f)return;const variants=selectedVariants(f),v=variants[0];q('button[type=submit]',f).disabled=variants.some(v=>!v?.available);if(!v)return;const price=q('[data-quick-price]',f.closest('.dm-quick-grid'));if(price)price.innerHTML=money(v.price)+(v.compare_at_price>v.price?` <s>${money(v.compare_at_price)}</s>`:'');if(v.featured_image?.src)q('.dm-quick-image').src=v.featured_image.src;});













document.addEventListener('submit',async e=>{const ebookForm=e.target.closest('[data-ebook-upsell]');if(ebookForm){e.preventDefault();const b=q('button',ebookForm);b.disabled=true;try{const v=products['la-verita-sul-ventre-postpartum'].variants.find(v=>v.available);await api('cart/add.js',{items:[{id:v.id,quantity:1}]});const c=await api('cart.js');await api('cart/update.js',{discount:[...(c.discount_codes||[]).map(d=>d.code),'DONNEA-CARRELLO-EBOOK'].join(',')});await cart();}catch(err){error(err,q('#dm-cart'));b.disabled=false;}return;}const upsellForm=e.target.closest('[data-cart-upsell]');if(upsellForm){e.preventDefault();const b=q('button',upsellForm);b.disabled=true;try{const p=products['reggiseno-minimizzatore-invisibile'],values=qa('select',upsellForm).map(x=>x.value),v=p.variants.find(v=>v.options.every((x,n)=>x===values[n]));if(!v?.available)throw new Error('Variante non disponibile.');await api('cart/add.js',{items:[{id:v.id,quantity:1}]});const c=await api('cart.js');await api('cart/update.js',{discount:[...(c.discount_codes||[]).map(d=>d.code),'DONNEA-CARRELLO-REGGISENO'].join(',')});await cart();}catch(err){error(err,q('#dm-cart'));b.disabled=false;}return;}const f=e.target.closest('[data-quick-form]');if(!f)return;e.preventDefault();const b=q('button[type=submit]',f);b.disabled=true;try{const variants=selectedVariants(f);if(variants.some(v=>!v?.available))throw new Error('Seleziona una variante disponibile.');await api('cart/add.js',{items:variants.map(v=>({id:v.id,quantity:1}))});if(f.dataset.offer)await api('cart/update.js',{discount:settings.offers[f.dataset.offer].code});await cart();close(q('#dm-quick'));open('dm-cart');}catch(err){error(err,q('#dm-quick'));}finally{b.disabled=false;}});













if(q('[data-dm-cart-page]'))cart().then(()=>open('dm-cart')).catch(e=>error(e,q('#dm-cart')));













if(!sessionStorage.getItem('dm-promo-dismissed')&&!new URLSearchParams(location.search).has('offerta'))setTimeout(()=>{if(!opened.length)open('dm-promo')},7000);













})();













